export default "__VITE_ASSET__hkLxA_SF__"